// extracted by mini-css-extract-plugin
export var displayNone = "_ls-6";
export var imgContainer = "_ls-2";
export var overflowHidden = "_ls-3";
export var productInfoCardButtonContainer = "_ls-5";
export var productTitleText = "_ls-4";
export var rightArrow = "_ls-1";
export var rightArrowContainer = "_ls-0";